import Page from '../page';

export default class ExpertisesIndex extends Page {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
        this._initTls();
    }

    _retrieveDOM() {
        this.dom.views = {};

    }
    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/expertises/expertises-index.js